import { EventMouseGantt } from "components/planner/types"
import { DateRange } from "types/global"



export interface PlannerTab {
	title: string
	type: PLANNER_TYPE
}

export enum PLANNER_TYPE {
	PRODUCTION,
	DRAFT,
}

/** Da un evento del mouse sul PLANNER restituisce un DATE-RANGE */
export function getRangeFromEvent(plannerEvent: EventMouseGantt, dateRange: DateRange) {
	const { dateSelect, event } = plannerEvent
	let range: DateRange = { start: null, end: null }

	// c'e' in corso la selezione del range...
	if (dateRange.start && !dateRange.end) {
		range = { ...dateRange, end: dateSelect }

		// sto premendo il tasto SHIFT
	} else if (event.shiftKey) {
		// non c'e' nulla di selezionato
		if (!dateRange.start && !dateRange.end) {
			range = { start: dateSelect, end: null }
			// è selezionata una specifica data
		} else if (dateRange.start && dateRange.start == dateRange.end) {
			range = { ...dateRange, end: dateSelect }
			// se è selezionatao gia' un RANGE
		} else if (dateRange.start && dateRange.end && dateRange.start != dateRange.end) {
			range = { start: Math.min(dateRange.start, dateSelect), end: Math.max(dateRange.end, dateSelect) }
		}
		// no selezione range: allora seleziono uno specifico giorno
	} else {
		range = { start: dateSelect, end: dateSelect }
	}
	return range
}


